import { createRoot } from 'react-dom/client';

import App from './App';
import { VariableProvider } from './context/ThemeContext';
import { initializeTooltip } from 'packages/radiant-react/tooltip';

initializeTooltip();

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('isDarkMode') === 'true') {
  document.documentElement.setAttribute('data-theme', 'dark');
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <VariableProvider>
    <App />
  </VariableProvider>
);
